<template>
  <div
    class="custom-fields-toolbar d-flex align-center justify-end"
    data-testid="setup-tasklist__custom-fields-toolbar"
  >
    <v-btn
      color="primary"
      class="custom-fields-toolbar__add-btn text-none white--text"
      :disabled="disabled"
      data-testid="setup-tasklist__add-custom-field-btn"
      @click="$emit('add-field')"
    >
      <v-icon left small>mdi-plus</v-icon>
      Custom Field
    </v-btn>
  </div>
</template>

<script>
import './CustomFieldsToolbar.scss';

export default {
  name: 'CustomFieldsToolbar',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
